export default "__VITE_ASSET__OQZbQ3gI__"